export default "__VITE_ASSET__CqU0KVH9__"